import { render, staticRenderFns } from "./PageFournisseurs.vue?vue&type=template&id=6006b7ca&scoped=true&"
import script from "./PageFournisseurs.vue?vue&type=script&lang=js&"
export * from "./PageFournisseurs.vue?vue&type=script&lang=js&"
import style1 from "./PageFournisseurs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006b7ca",
  null
  
)

export default component.exports